import { useState, useMemo, useRef } from "react"
import { useParams } from "react-router-dom"
import { Respuesta } from "../components/Respuesta.js"
import { AsyncButton } from "../components/ui/AsyncButton.js"
import Container from "../components/ui/Container.js"
import { ModalError } from "../components/ui/modal/ModalError.js"
import { ModalOk } from "../components/ui/modal/ModalOk.js"
import { msg } from "../components/ui/modal/utils.js"
import { meets } from "../helpers/jwt.js"
import useFetch from "../hooks/useFetch.js"
import { useQuery } from "../hooks/useQuery.js"
import { api } from "../services/api/index.js"

import "./Consigna.scss"
import { useTranslation } from "react-i18next"

const ConsignaAdminView = ({ con }) => {
  return (
    <>
      <Container>
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col col-lg-5 col-12">
              <center className="mb-5 mt-4">
                <small>
                  <b>{con.respuestas.length}</b> respuestas para:
                </small>
                <h3>{con.titulo}</h3>
                <br />
                <small>
                  - Selecciona texto en las respuestas para marcar errores
                  <br />- Clickea los resaltadores rojos para editarlos
                </small>
              </center>
              {con.respuestas.map((resp, rix) => (
                <Respuesta
                  key={rix}
                  con_id={con.id}
                  respuesta={resp}
                  editable={true}
                />
              ))}
            </div>
          </div>
        </div>
      </Container>
    </>
  )
}

const ConsignaStudentView = ({ con }) => {
  // elements
  const form = useRef()

  // estado
  const [contenido, setContenido] = useState("")

  // ajax
  const addRespuesta = useQuery(),
    showRes = useState(false)

  // post-porc
  const cleanForm = () => {
    form.current.reset()
    setContenido("")
  }

  const onSubmitForm = async (e) => {
    e.preventDefault()
    showRes[1](true)

    const { url, opt } = api.consignas.add_respuesta({
      con_id: con.id,
      contenido: contenido,
    })

    addRespuesta.url.current = url
    addRespuesta.opt.current = opt
    addRespuesta.run({
      onOk: (data) => {
        cleanForm()
        setTimeout(() => {
          const new_url =
            window.location.href + `/respuestas/${data.respuesta_id}`
          window.location.href = new_url
        }, 1000)
      },
    })
  }

  return (
    <>
      {addRespuesta.res && !addRespuesta.err && (
        <ModalOk
          show={showRes}
          body={msg(<>Tu respuesta ha sido enviada con éxito.</>)}
        />
      )}

      {addRespuesta.res && addRespuesta.err && (
        <ModalError id="err-res" show={showRes} res={addRespuesta.res} />
      )}

      <Container>
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col col-lg-5 col-12">
              <center>
                <h3 className="mt-5">{con.titulo}</h3>
              </center>
              <form ref={form}>
                <textarea
                  onChange={(e) => setContenido(e.target.value)}
                  className="form-control my-4"
                  rows="3"
                  placeholder="Write here..."></textarea>
                <div className="d-flex flex-row justify-content-end">
                  <AsyncButton
                    onClick={onSubmitForm.bind(this)}
                    name="Send"
                    sendingName="Sending"
                    disabled={addRespuesta.isPending}
                    sending={addRespuesta.isPending}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </Container>
    </>
  )
}

const ConsignaView = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { url, opt } = useMemo(
      () =>
        api.consignas.readOne({
          id,
          include_answers: meets(["admin", "teacher"]) ? true : false,
        }),
      [id]
    ),
    [consigna, isPending, err] = useFetch({ url, opt })

  if (!id) return <Container />

  if (isPending && !err)
    return (
      <>
        <Container>
          <center>{t("ui.btns.loading")}...</center>
        </Container>
      </>
    )

  if (meets(["admin", "teacher"])) return <ConsignaAdminView con={consigna} />

  return <ConsignaStudentView con={consigna} />
}

export default ConsignaView
